function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "../Button/index.js";
import { Card } from "../Card/index.js";
import { Pill } from "../Pill/index.js";
import { Typography } from "../Typography/index.js";
import { cn } from "../../common/helpers.js";
import CardAccordionCollapsible from "./CardAccordionCollapsible.js";
/**
 *
 * Card accordion - [API](https://scl.sharp.com/?path=/docs/components-cardaccordion) | [DSM](https://sharphealthcare.notion.site/Card-accordion-item-c708ee2902644eea8612766ade022916)
 *
 * @example
 *
 * <CardAccordion
 *  preHeading="This is a featured variant"
 *  image={{ alt: 'test', src: 'placeholder-image-16-9.jpg' }}
 *  title="My Card Accordion"
 *  decorator="$$"
 *  collapsible={{ title: 'This is expandable' }}>
 *  Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sequi, suscipit.
 * </CardAccordion>
 *
 * <CardAccordion
 *  preHeading="This is a featured variant"
 *  image={{ alt: 'test', src: 'placeholder-image-16-9.jpg' }}
 *  title="My Card Accordion"
 *  decorator="$$" />
 */ const CardAccordion = /*#__PURE__*/ forwardRef((props, ref)=>{
    var _slotProps_preHeading, _slotProps_preHeading1;
    const { as, className, preHeading, image = {}, heading, decorator, description, labels, button, collapsibleTitle, children, slots = {}, slotProps = {}, collapsible } = props, rootProps = _object_without_properties(props, [
        "as",
        "className",
        "preHeading",
        "image",
        "heading",
        "decorator",
        "description",
        "labels",
        "button",
        "collapsibleTitle",
        "children",
        "slots",
        "slotProps",
        "collapsible"
    ]);
    const Root = as !== null && as !== void 0 ? as : Card;
    // Preheading
    const hasPreheading = !!(preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps_preHeading = slotProps.preHeading) === null || _slotProps_preHeading === void 0 ? void 0 : _slotProps_preHeading.children);
    var _slots_preHeading;
    const PreHeading = (_slots_preHeading = slots.preHeading) !== null && _slots_preHeading !== void 0 ? _slots_preHeading : Typography;
    const defaultPreHeadingStyles = {
        variant: 'small-body-semibold',
        align: 'center'
    };
    var _slotProps_preHeading2;
    const _ref = (_slotProps_preHeading2 = slotProps.preHeading) !== null && _slotProps_preHeading2 !== void 0 ? _slotProps_preHeading2 : {}, { className: preHeadingClassNameSlotProps } = _ref, preHeadingSlotPropsRest = _object_without_properties(_ref, [
        "className"
    ]);
    const preHeadingProps = slots.preHeading ? preHeadingSlotPropsRest : _object_spread({}, defaultPreHeadingStyles, preHeadingSlotPropsRest);
    var _slots_image;
    // Image
    const Image = (_slots_image = slots.image) !== null && _slots_image !== void 0 ? _slots_image : 'img';
    const { className: imagePropClassName } = image, imagePropProps = _object_without_properties(image, [
        "className"
    ]);
    var _slotProps_image;
    const _ref1 = (_slotProps_image = slotProps.image) !== null && _slotProps_image !== void 0 ? _slotProps_image : {}, { className: imageSlotPropsClassName } = _ref1, imageSlotProps = _object_without_properties(_ref1, [
        "className"
    ]);
    const imageProps = slots.image ? imageSlotProps : _object_spread({}, imagePropProps, imageSlotProps);
    var _slots_heading;
    // heading
    const Heading = (_slots_heading = slots.heading) !== null && _slots_heading !== void 0 ? _slots_heading : Typography;
    const defaultHeadingProps = {
        variant: 'h4',
        as: 'h3'
    };
    var _slotProps_heading;
    const _ref2 = (_slotProps_heading = slotProps.heading) !== null && _slotProps_heading !== void 0 ? _slotProps_heading : {}, { className: headingClassNameSlotProps, children: headingChildren } = _ref2, restHeadingSlotProps = _object_without_properties(_ref2, [
        "className",
        "children"
    ]);
    const headingProps = slots.heading ? slotProps.heading : _object_spread({}, defaultHeadingProps, restHeadingSlotProps);
    var _slots_decorator;
    // decorator
    const Decorator = (_slots_decorator = slots.decorator) !== null && _slots_decorator !== void 0 ? _slots_decorator : Typography;
    const defaultDecoratorStyle = {
        variant: 'body-semibold',
        align: 'right'
    };
    var _slotProps_decorator;
    const _ref3 = (_slotProps_decorator = slotProps.decorator) !== null && _slotProps_decorator !== void 0 ? _slotProps_decorator : {}, { className: decoratorClassNameSlotProps, children: decoratorChildren } = _ref3, restDecoratorSlotProps = _object_without_properties(_ref3, [
        "className",
        "children"
    ]);
    const decoratorProps = slots.decorator ? slotProps.decorator : _object_spread({}, defaultDecoratorStyle, restDecoratorSlotProps);
    var _slots_description;
    // description
    const Summary = (_slots_description = slots.description) !== null && _slots_description !== void 0 ? _slots_description : Typography;
    var _slotProps_description;
    const _ref4 = (_slotProps_description = slotProps.description) !== null && _slotProps_description !== void 0 ? _slotProps_description : {}, { className: descriptionClassNameSlotProps, children: descriptionChildren } = _ref4, restSummarySlotProps = _object_without_properties(_ref4, [
        "className",
        "children"
    ]);
    var _slots_labelContainer;
    // pills container
    const LabelContainer = (_slots_labelContainer = slots.labelContainer) !== null && _slots_labelContainer !== void 0 ? _slots_labelContainer : 'div';
    var _slotProps_labelsContainer;
    const _ref5 = (_slotProps_labelsContainer = slotProps.labelsContainer) !== null && _slotProps_labelsContainer !== void 0 ? _slotProps_labelsContainer : {}, { className: labelContainerClassNameSlotProps } = _ref5, restLabelContainerSlotProps = _object_without_properties(_ref5, [
        "className"
    ]);
    var _slots_buttonContainer;
    // button container
    const ButtonContainer = (_slots_buttonContainer = slots.buttonContainer) !== null && _slots_buttonContainer !== void 0 ? _slots_buttonContainer : 'div';
    var _slotProps_buttonContainer;
    const _ref6 = (_slotProps_buttonContainer = slotProps.buttonContainer) !== null && _slotProps_buttonContainer !== void 0 ? _slotProps_buttonContainer : {}, { className: buttonContainerSlotPropsClassName } = _ref6, buttonContainerSlotProps = _object_without_properties(_ref6, [
        "className"
    ]);
    var _slots_button;
    const ButtonComponent = (_slots_button = slots.button) !== null && _slots_button !== void 0 ? _slots_button : Button;
    const buttonProps = slots.button ? slotProps.button : _object_spread({}, button, slotProps.button);
    var _image_src;
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, !as && {
        variant: 'filled',
        padding: 'none'
    }), {
        className: cn('h-fit pb-6', hasPreheading && 'rounded-t-none', className),
        ref: ref
    }), rootProps), {
        children: [
            hasPreheading && /*#__PURE__*/ _jsx(PreHeading, _object_spread_props(_object_spread({
                className: cn('bg-primary-100 py-2 leading-none -mx-0.5 -mt-[1.875rem] rounded-t-xl', preHeadingClassNameSlotProps)
            }, preHeadingProps), {
                children: preHeading !== null && preHeading !== void 0 ? preHeading : (_slotProps_preHeading1 = slotProps.preHeading) === null || _slotProps_preHeading1 === void 0 ? void 0 : _slotProps_preHeading1.children
            })),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center gap-x-4 mt-6 px-6",
                children: [
                    ((_image_src = image.src) !== null && _image_src !== void 0 ? _image_src : slotProps.image) && /*#__PURE__*/ _jsx(Image, _object_spread({
                        className: cn('rounded-full h-15 w-15 object-cover', imageSlotPropsClassName)
                    }, imageProps)),
                    /*#__PURE__*/ _jsx(Heading, _object_spread_props(_object_spread({
                        className: cn('flex-grow', headingClassNameSlotProps)
                    }, headingProps), {
                        children: heading
                    })),
                    (decorator !== null && decorator !== void 0 ? decorator : decoratorChildren) && /*#__PURE__*/ _jsx(Decorator, _object_spread_props(_object_spread({
                        className: cn('font-bold', decoratorClassNameSlotProps)
                    }, decoratorProps), {
                        children: decorator !== null && decorator !== void 0 ? decorator : decoratorChildren
                    }))
                ]
            }),
            (description !== null && description !== void 0 ? description : descriptionChildren) && // `mr-4` cheats into right card gutter to give a little more wiggle room for content.
            /*#__PURE__*/ _jsx(Summary, _object_spread_props(_object_spread({
                className: cn('mt-4 ml-6 mr-4', descriptionClassNameSlotProps)
            }, restSummarySlotProps), {
                children: description !== null && description !== void 0 ? description : descriptionChildren
            })),
            labels && /*#__PURE__*/ _jsx(LabelContainer, _object_spread_props(_object_spread({
                className: cn('flex flex-row flex-wrap mt-4 gap-x-3 gap-y-1 mx-6', labelContainerClassNameSlotProps)
            }, restLabelContainerSlotProps), {
                children: labels.map((label, ndx)=>/*#__PURE__*/ _jsx(Pill, _object_spread({}, label), ndx))
            })),
            button && /*#__PURE__*/ _jsx(ButtonContainer, _object_spread_props(_object_spread({
                className: cn('mt-5 mx-6', buttonContainerSlotPropsClassName)
            }, buttonContainerSlotProps), {
                children: /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({
                    size: "sm",
                    width: "full"
                }, buttonProps))
            })),
            collapsibleTitle && /*#__PURE__*/ _jsx(CardAccordionCollapsible, _object_spread_props(_object_spread({
                title: collapsibleTitle,
                slots: slots,
                slotProps: slotProps
            }, collapsible), {
                children: children
            }))
        ]
    }));
});
export { CardAccordion };
